import { loadNextStepModule } from "../modules/loadNextStepModule";
import { fadeOutStep } from "./stepAnimations";


/**
 * 
 * @param {Product365} product365 
 * @param {Product} product 
 * @param {Cart} cart 
 */
export function initAddOnStep(product365, product, cart) {
    let continueFormButtons = document.querySelectorAll(".form-question-col.addons .continue-form-button") ? document.querySelectorAll(".form-question-col.addons .continue-form-button") : null;
    if (continueFormButtons) {
        for (let continueFormButton of continueFormButtons) {

            let addOnsGroups = document.querySelectorAll(".checkbox-group")
            continueFormButton.addEventListener("click", (e) => {
                e.preventDefault();

                for (let addOnsGroup of addOnsGroups) {
                    let input = addOnsGroup.querySelector("input");
                    let checkmark = addOnsGroup.querySelector(".checkmark")
                    let addOnId = input.dataset.bundleElementId;

                    if (input.checked || checkmark.classList.contains("checked")) {
                        product.addAddOn(addOnId)
                    }
                }
                // Either laod cart and add stuff to local storage, or load places step
                loadNextStepModule.getNextStep('places', product.get().name)

                let formStepHolder = document.getElementById("form-question-addons")
                fadeOutStep(formStepHolder.parentElement);

            })


        }
    }

}